module.exports = __webpack_public_path__ + "asset/shunjianActive_lbgC7JQs.png";